import { AppEntities } from "../../../../config/entities";
import { CatalogListView } from "../../../Shared/CatalogListView";
import { CatalogListViewDefaultToolbarButtons } from "../../../Shared/ListViews/CatalogListViewDefaultToolbarButtons";
import { CatalogListViewToolbar } from "../../../Shared/ListViews/CatalogListViewToolbar";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";
const BankAccountList = () => {
  const fields = [
    { title: "Name", fieldName: "name" },
    { title: "Account #", fieldName: "accountNumber" },
    { title: "Company", fieldName: "companyName" },
    { title: "Bank", fieldName: "bankName" },
    { title: "Currency", fieldName: "currencyName" }
  ];

  return (
    <>
      <CatalogListView fields={fields} entity={AppEntities.BankAccount}>
        <CatalogListViewToolbar>
          <CatalogListViewDefaultToolbarButtons />
        </CatalogListViewToolbar>
      </CatalogListView>{" "}
    </>
  );
};

export default BankAccountList;
